export { default } from './SubscriptionTypeLabel'
